module.exports = __webpack_public_path__ + "static/img/OXFORD-MAPLE.43c5a85.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/OXFORD-MAPLE.png
// module id = 45fN
// module chunks = 0